/**
* @file 安检模板
* */
<template>
  <div id="securityTemplate">

    <!-- 模态框 -->
    <el-dialog :visible.sync="dialogVisible" :title="`${form.id ? '编辑' : '创建'}项目`"
               @close="$refs.form.resetFields(); form.id = null;" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="left">
        <el-form-item label="项目名称" prop="name">
          <el-input v-model="form.name" maxlength="15"></el-input>
        </el-form-item>
        <el-form-item label="检查内容" prop="content">
          <el-input v-model="form.content" maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="上传照片" prop="needPhoto">
          <el-radio-group v-model="form.needPhoto">
            <el-radio :label="true">必填</el-radio>
            <el-radio :label="false">非必填</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item style="margin-top: 30px; text-align: right;">
          <el-button @click=" dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <custom-table ref="customTable" addText="添加" @addFn="addFn({})" :customOptions="customOptions"
                  :columns="columns">
      <template slot="search-top-right">
        <el-button  type="primary" @click="setFeeStatus = true">设置安检费用</el-button>
      </template>
      <template slot="search-top-left">
        <div style="color:#999">说明：配置安检员端的营运客车安全检查项</div>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" width="200" fixed="right">
          <div slot-scope="{row}" class="custom-action">
            <el-button type="text" style="margin-right: 15px;" @click=" addFn(row)">向上插入</el-button>
            <el-tooltip content="编辑" placement="top">
              <i class="iconfont icon-compile" @click=" compileClick(row)"></i>
            </el-tooltip>
            <el-tooltip content="删除" placement="top">
              <i v-if="mixinUserInfo.id !== row.id" class="iconfont icon-delete" @click=" removeClick(row)"></i>
            </el-tooltip>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{item, row}">
        <div v-if="item.prop == 'needPhoto'" :style="{ color: row.needPhoto ? 'black' : '#999' }">
          {{ row.needPhoto ? '必填' : '非必填' }}
        </div>
        <span v-else>{{ row[item.prop] }}</span>
      </template>
    </custom-table>


    <el-dialog
        title="设置安检费用"
        :before-close="handClose"
        :visible.sync="setFeeStatus"
        destroy-on-close
        width="400px">
      <setFee  @handClose="handClose" v-if="setFeeStatus"></setFee>
    </el-dialog>
  </div>
</template>

<script>
import setFee from './components/setFee'
export default {
  name: "securityTemplate",
  components:{
    setFee
  },
  data() {
    return {
      setFeeStatus:false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/inspectTemplate',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20 // 每页条数
        }
      },
      columns: [
        {prop: 'sort', label: '序号'},
        {prop: 'name', label: '项目名称'},
        {prop: 'content', label: '检查内容'},
        {prop: 'needPhoto', label: '上传照片'}
      ],

      dialogVisible: false,
      form: {},
      rules: {
        name: [{required: true, message: '请输入项目名称'}],
        content: [{required: true, message: '请输入检查内容'}],
        needPhoto: [{required: true, message: '请选择照片是否必填'}]
      },
      loading: false,

    }
  },
  methods: {
    handClose(){
      this.setFeeStatus = false
    },
    /* 插入 */
    addFn(row) {
      this.dialogVisible = true;
      this.form = {sort: row?.sort || '', needPhoto: false}
    },
    /* 编辑 */
    compileClick(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.form = {...row};
      })
    },
    /* 删除 */
    removeClick(row) {
      if (this.$refs.customTable.table.total == 1) {
        this.$message.info('至少保留1条数据!')
        return;
      }
      this.$confirm("确认删除吗？", "删除提示").then(async () => {
        let url = '/api/v1/manage/inspectTemplate'
        let data = await this.$axios.delete(url, {id: row.id})
        if (data && data.code == 1) {
          this.$message.success('删除成功')
          this.$refs.customTable.listFn()
        }
      });
    },

    /* 点击保存 */
    async saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postFn();
        } else {
          this.$message.warning('请检查表单数据是否输入正确！');
          return false;
        }
      });
    },
    /* 接口请求-提交 */
    async postFn() {
      this.loading = true;
      let url = '/api/v1/manage/inspectTemplate';
      let params = this.$utils.deepCopyFn(this.form);
      let data = await this.$axios[params.id ? 'put' : 'post'](url, params);
      if (data && data.code == 1) {
        this.$message.success('保存成功！')
        this.$refs.customTable.listFn();
      }
      this.loading = false;
      this.dialogVisible = false;
    },
  }
}
</script>

